<template>
    <v-container>
        <v-card class="mb-10">
            <v-card-title class="card-title">League Group Form</v-card-title>
        </v-card>
        <v-form :readonly="readOnly">
            <v-row>
                <v-col cols="12">
                    <v-text-field
                        v-model="leagueGroup.title"
                        label="Title"
                        type="text"
                        :clearable="clearable"
                    />
                </v-col>
            </v-row>
        </v-form>
        <div v-if="mode !== 'show'" class="submit-button-wrapper">
            <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit()" :loading="loading" large color="black" @click="onSubmit">
                Submit
            </v-btn>
            <v-btn class="mx-2 white--text" large color="red" @click="$router.go(-1)">
                Cancel
            </v-btn>
        </div>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import leagueGroupService from '@/services/leagueGroup'
    import Alert from '@/components/Alert'

    export default {
        name: 'LeagueForm',
        components: { Alert },
        data: () => {
            return {
                showAlert: false,
                message: null,
                type: null,
                loading: false,
                mode: null,
                leagueGroup: {},
                leagueGroupId: null,
                readOnly: false,
                clearable: true,
                rules: [
                    v => !!v || 'Field is required'
                ]
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'show') {
                this.readOnly = true
                this.clearable = false
            }
            this.leagueGroupId = this.$route.params.leagueGroupId
            if (this.$route.params.leagueGroupId) {
                leagueGroupService.getLeagueGroup(this.$route.params.leagueGroupId).then(resp => {
                    this.leagueGroup = resp.data
                })
            }
        },
        methods: {
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            shouldDisableSubmit() {
                return false
            },
            createLeagueGroup() {
                this.loading = true
                leagueGroupService.createLeagueGroup(this.leagueGroup).then(leagueResponse => {
                    if (leagueResponse.id) {
                        this.leagueGroupId = leagueResponse.id
                    }
                    this.loading = false
                    this.$router.push(`/league-groups`)
                }).catch((error) => {
                    this.loading = false
                    this.setAlert(error.response.data.message, 'error')
                })
            },
            editLeagueGroup() {
                this.loading = true
                leagueGroupService.updateLeagueGroup(this.leagueGroupId, this.leagueGroup).then((response) => {
                    this.loading = false
                    this.$router.push(`/league-groups`)
                }).catch((error) => {
                    this.setAlert(error.response.data.message, 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editLeagueGroup()
                } else if (this.mode === 'create') {
                    this.createLeagueGroup()
                }
            }
        }

    }
</script>
<style>
.tox .tox-editor-header {
    z-index: 0 !important;
}
.tox .tox-statusbar {
    display: none !important;
}

.tox .tox-toolbar--scrolling {
    flex-wrap: wrap !important;
}
.tox.tox-tinymce.tox-platform-touch {
    height: 40vh !important;
    min-height: 350px;
}
</style>
<style scoped>
.body-label {
    color: rgba(0, 0, 0, 0.6);
}
.body-editor {
    margin-bottom: 2vh;
}
.edit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.img-preview {
    max-width: 70%;
    margin: 0 auto;
}

.image-input {
    padding: 20px;
    width: 100%;
    border-style: groove;
    border: #D3D3D3 solid 2px;
    border-radius: 15px 50px;
    margin-top: 1vh;
}

.green-border {
    border-color: green;
}

.delete-btn {
    display: flex;
    justify-content: flex-end;
}
</style>
